export const splitStatisticFromDescription = (text: string): { statistic: string; description: string } => {
  const regex = /^((?:€|£|\$|¥)?[\d,]+(?:\.\d+)?(?:\s*(?:million|billion|thousand|k|m|b|%))?)\s+(.*)/i;

  const match = text.match(regex);

  if (match) {
    return {
      statistic: match[1].trim(),
      description: match[2].trim(),
    };
  } else {
    return {
      statistic: null,
      description: text,
    };
  }
};
